// extracted by mini-css-extract-plugin
export default {"container":"WordGameLayout_container__DLWeZ","sub_container":"WordGameLayout_sub_container__IrNxr"};